import { useCurrentWorkspace } from "src/api/queries";
import { useIsFeatureFlagEnabled } from "src/hooks/useIsFeatureFlagEnabled";
import { FEATURE_FLAGS } from "src/router/featureFlags";

type PerformanceInAnalyticsAccess = {
  isEnabled: boolean;
  isLoading: boolean;
};

// Callers must hold off while `isLoading`: treating an unloaded workspace as
// not enabled renders the standalone Performance page before the redirect.
export const usePerformanceInAnalyticsAccess =
  (): PerformanceInAnalyticsAccess => {
    const { data: workspace, isLoading } = useCurrentWorkspace();
    const isFlagEnabled = useIsFeatureFlagEnabled(
      FEATURE_FLAGS.performanceInAnalytics,
    );
    return {
      isEnabled:
        isFlagEnabled ||
        Boolean(workspace?.config?.enable_performance_in_analytics),
      isLoading,
    };
  };
